import { Organisation } from '@/features'
import { APIClient } from '@/services'

export type UseOrganisationProps = { id: Organisation.T.Organisation['id'] }

export function useOrganisation({ id }: UseOrganisationProps) {
  const organisation = APIClient.Organisations.organisationsManager.useItem({
    id,
    queryOptions: {
      enabled: !!id
    }
  })

  // @ts-ignore
  const notFound = organisation.query.isError && organisation.query?.error?.status === 404

  return { organisation, notFound }
}
